module.exports = __webpack_public_path__ + "static/img/product7.20b3fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product7.jpg
// module id = OUsS
// module chunks = 0